import React, { Component } from "react";
import goldlog from "@ali/goldlog";
import { Input, CascaderSelect, Feedback, Balloon } from "@alife/next";
import {
  cplRepo,
  getLogin,
  queryMobilePhone,
  sendSmsCode,
  getCplAuthList,
  cplAuthDelete,
  getIntent,
  getIsSubcategory,
  getSuggestKeywordList,
} from "../../../../service";
import CountdownButton from "./countdownButton";
import { getUrlParam } from "../../../util/common";
import TagSelectPopover from "./tagDialog";
import "./index.scss";
import classNames from "classnames";

const getLeadsId = (response) => {
  const data = response && response.data;

  return (response && response.leadsId)
    || (data && (data.leadsId || (data.data && data.data.leadsId)));
};

const staticData = [
  {
    value: 3 * 24 * 60 * 60 * 1000,
    label: '快速采购（3天）'
  },
  {
    value: 7 * 24 * 60 * 60 * 1000,
    label: "临时采购（7天）",
  },
  {
    value: 14 * 24 * 60 * 60 * 1000,
    label: "正常采购（14天）",
  },
  {
    value: 30 * 24 * 60 * 60 * 1000,
    label: "生产采购（30天）",
  },
  {
    value: 90 * 24 * 60 * 60 * 1000,
    label: "季度采购（90天）",
  },
];

function formatTimestamp(timestamp) {
  // 创建一个新的 Date 对象
  const date = new Date(timestamp);

  // 获取年份、月份和日期
  const year = date.getFullYear().toString(); // 取后两位
  const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需加 1
  const day = String(date.getDate()).padStart(2, "0");

  // 返回格式化后的日期字符串
  return `${year}-${month}-${day}`;
}

export default class LeadsCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardShowState: true,
      keyword: window.pageConfig.keywords,
      mobilePhone: "",
      nlq: "",
      //volumn: '',
      authDeadline: Date.now() + 604800000,
      isLogin: false,
      isNeedVerification: false,
      formSending: false,
      smsCode: "",
      time: 14 * 24 * 60 * 60 * 1000,
      showHistory: false,
      historyList: [],
      submitFlag: false,
      btnTipVisible: false,
      btnTipId: null,
      intent: [],
      intentInTextarea: [],
      showPopover: false,
      popoverPosition: null,
      oldcConfirmedTagValues: [],
      leadsDataSource: [],
    };

    this.handleChangeCascaderSelect =
      this.handleChangeCascaderSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSmsCode = this.getSmsCode.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSmsCodeChange = this.handleSmsCodeChange.bind(this);
    this.isLogin = this.isLogin.bind(this);
    this.handleToHistory = this.handleToHistory.bind(this);
    this.renderForm = this.renderForm.bind(this);
    this.renderHistory = this.renderHistory.bind(this);
    this.getHistory = this.getHistory.bind(this);
    this.handleBackToForm = this.handleBackToForm.bind(this);
    this.handleStop = this.handleStop.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.handleTagsConfirm = this.handleTagsConfirm.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.getIntent = this.getIntent.bind(this);
    this.handleKeywordBlur = this.handleKeywordBlur.bind(this);
    this.onChangeLeadsKeyword = this.onChangeLeadsKeyword.bind(this);
    this.renderGoodsList = this.renderGoodsList.bind(this);

    this.textareaRef = null;

    // 搜索关键词防抖
    this.debounceTimer = null;
    this.requestCounter = 0;
  }

  async componentDidMount() {
    if (this.getItemWithExpiration("closeLeadsCard")) {
      this.setState({
        cardShowState: false,
      });
    }

    try {
      if (
        !this.getItemWithExpiration("closeLeadsCard") &&
        this.state.cardShowState
      ) {
        goldlog &&
          goldlog.record(
            "/ifission.ifission.leadsCardExp",
            "EXP",
            "position=card"
          );
      } else {
        goldlog &&
          goldlog.record(
            "/ifission.ifission.leadsCardExp",
            "EXP",
            "position=icon"
          );
      }
    } catch (error) {
      console.log(error);
    }

    const isLogin = await getLogin();

    if (isLogin) {
      const mobilePhone = await queryMobilePhone();
      this.setState({
        mobilePhone,
      });
    }

    this.setState({
      isLogin,
    });

    const keywords = getUrlParam("keywords");
    this.getIntent(keywords);
  }

  async getIntent(keywords) {
    //获取标签
    const intent = await getIntent(keywords);
    if (intent.code === "200") {
      let intentList = intent.data;
      let intentInTextarea = [];

      var allPossibleTagValues = [];

      intentList.map((intent) => {
        let intentValueList = intent.v;
        if (intentValueList && intentValueList.length > 0) {
          intentInTextarea.push(intentValueList[0]);
        }

        if (intent.v && Array.isArray(intent.v)) {
          intent.v.forEach(function (tagObj) {
            if (tagObj.v && allPossibleTagValues.indexOf(tagObj.v) === -1) {
              allPossibleTagValues.push(tagObj.v); // Add tag value if not already present
            }
          });
        }

        intent.v = intent.v.slice(1, 6);

        switch (intent.k) {
          case "BUYER":
            intent.title = "采购信息";
            break;
          case "OFFER":
            intent.title = "商品需求";
            break;
          case "SERVICE":
            intent.title = "服务需求";
            break;
          case "OTHER":
            intent.title = "其他要求";
            break;

          default:
            break;
        }
      });

      console.log(intentInTextarea, 1111);
      intentInTextarea = intentInTextarea.slice(0, 3);
      console.log(allPossibleTagValues);

      this.setState({
        intent: intentList,
        intentInTextarea,
        availableTagValues: allPossibleTagValues,
      });
    }
  }

  handleToHistory() {
    this.getHistory();
    this.setState({
      showHistory: true,
    });
  }

  async getHistory() {
    const list = await getCplAuthList();
    console.log(list);
    this.setState({
      historyList: list,
    });
  }

  handleBackToForm() {
    this.setState({
      showHistory: false,
    });
  }

  setItemWithExpiration(key, value) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + 24 * 60 * 60 * 1000, // 当前时间加一天的毫秒数
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItemWithExpiration(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  handleClose() {
    this.setItemWithExpiration("closeLeadsCard", true);
    goldlog.record("/ifission.ifission.leadsCardClk", "CLK", `position=close`);

    this.props.onClose && this.props.onClose();
  }

  handleOpen() {
    this.setState({
      cardShowState: true,
    });

    localStorage.removeItem("closeLeadsCard");

    goldlog.record("/ifission.ifission.leadsCardClk", "CLK", `position=open`);
  }

  handleSmsCodeChange(val) {
    this.setState({
      smsCode: val,
    });
  }

  handleChangeCascaderSelect(time) {
    const currentTimestamp = Date.now();
    let authDeadline = currentTimestamp + time;

    this.setState({
      time,
      authDeadline,
    });
  }

  async handleSubmit() {
    if (this.state.submitFlag) {
      return;
    }

    this.setState({
      submitFlag: true,
    });

    let {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline,
      isNeedVerification,
      smsCode,
    } = this.state;

    if (!this.checkKeyword(keyword)) {
      this.setState({
        submitFlag: false,
      });
      return;
    }

    const isSubcategory = await getIsSubcategory(keyword);
    console.log(isSubcategory);
    if (isSubcategory === "false" || isSubcategory === false) {
      Feedback.toast.show({
        type: "error",
        content: "您填写的采购商品可能不太正确，请重新填写后提交",
        size: "large",
      });
      this.setState({
        submitFlag: false,
      });
      return;
    }

    if (!mobilePhone.includes("****")) {
      if (!this.phoneNumberCheck(mobilePhone)) {
        this.setState({
          submitFlag: false,
        });
        return;
      }
    } else {
      mobilePhone = "";
    }

    // 存在风险，验证码必填
    if (isNeedVerification) {
      if (!this.checkSmsCodeAndNlq(smsCode, nlq)) {
        this.setState({
          submitFlag: false,
        });
        return;
      }
    }

    let params = {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      authDeadline,
    };

    if (smsCode && smsCode.length > 0) {
      params.smsCode = smsCode;
    }

    //console.log(params);

    const res = await cplRepo(params);

    this.setState({
      submitFlag: false,
    });

    if (Number(res.code) === 4010) {
      this.setState({
        isNeedVerification: true,
      });
      Feedback.toast.show({
        type: "error",
        content: "请填写验证码",
        size: "large",
      });
    } else if (res.code === "200") {
      Feedback.toast.show({
        type: "success",
        content: "您的采购需求已提交，请保持电话畅通，商家会尽快联系您",
        size: "large",
      });

      this.setState({
        isNeedVerification: false,
        keyword: "",
        nlq: "",
        smsCode: "",
        time: 14 * 24 * 60 * 60 * 1000,
      });
      if (typeof this.props.onAgentSessionCreated === "function") {
        const leadsId = getLeadsId(res);
        if (leadsId) {
          this.props.onAgentSessionCreated({
            leadsId: String(leadsId),
            keyword,
          });
        }
      }
    } else {
      Feedback.toast.show({
        type: "error",
        content: res.msg,
        size: "large",
      });
    }

    goldlog.record("/ifission.ifission.leadsCardClk", "CLK", `position=submit`);
  }

  checkKeyword(keyword) {
    if (!keyword || keyword.trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "采购商品不能为空",
        size: "large",
      });
      return false;
    }

    return true;
  }

  checkSmsCodeAndNlq(smsCode, nlq) {
    if (!smsCode) {
      Feedback.toast.show({
        type: "error",
        content: "请填写验证码",
        size: "large",
      });
      return false;
    }
    // 存在风险，留言信息必填
    if (!nlq) {
      Feedback.toast.show({
        type: "error",
        content: "请填写留言信息",
        size: "large",
      });
      return false;
    }
    return true;
  }

  phoneNumberCheck(phoneNumber) {
    const phoneNumReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (("" + phoneNumber).trim() === "") {
      Feedback.toast.show({
        type: "error",
        content: "电话号码不能为空",
        size: "large",
      });
      return false;
    } else if (!phoneNumReg.test(phoneNumber)) {
      Feedback.toast.show({
        type: "error",
        content: "请填写正确的电话号码",
        size: "large",
      });
      return false;
    }
    return true;
  }

  getSmsCode() {
    let { mobilePhone } = this.state;

    if (!mobilePhone.includes("****")) {
      if (this.phoneNumberCheck(mobilePhone)) {
        this.sendSmsCode(mobilePhone);
      }
    } else {
      this.sendSmsCode(null);
    }
  }

  async handleStop(id) {
    const res = await cplAuthDelete(id);
    console.log(res);
    if (res.code === "200") {
      Feedback.toast.show({
        type: "success",
        content: "需求已停止，如需开启请重新提交",
        size: "large",
      });

      this.getHistory();
    } else {
      Feedback.toast.show({
        type: "error",
        content: res.msg,
        size: "large",
      });
    }
  }

  isLogin() {
    return this.getCookie("__cn_logon_id__");
  }

  getCookie(sKey) {
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            `(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(
              /[\-\.\+\*]/g,
              "\\$&"
            )}\\s*\\=\\s*([^;]*).*$)|^.*$`
          ),
          "$1"
        )
      ) || null
    );
  }

  async sendSmsCode(mobilePhone) {
    const code = await sendSmsCode(mobilePhone ? mobilePhone + "" : null);
    if (Number(code) === 200) {
      Feedback.toast.show({
        type: "prompt",
        content: "验证码已发送",
        size: "large",
      });
    } else if (Number(code) === 4012) {
      Feedback.toast.show({
        type: "prompt",
        content: "短信验证码已发送,请稍后再试",
        size: "large",
      });
    }
  }

  togglePopover() {
    var self = this;
    this.setState(function (prevState) {
      if (!prevState.showPopover) {
        var buttonRect = self.moreButtonRef.getBoundingClientRect();
        console.log(buttonRect);
        return {
          showPopover: true,
          popoverPosition: {
            bottom: 280, // 弹窗高度约450px，上方留10px间距
            right: 31,
          },
        };
      }
      return {
        showPopover: false,
        popoverPosition: null,
      };
    });
  }

  handleTagsConfirm(confirmedTagValues, intent) {
    console.log(confirmedTagValues, intent);

    const isExactMatch = (a, b) =>
      a.length === b.length && a.every((item, index) => item === b[index]);

    this.setState({ showPopover: false });
    if (isExactMatch(confirmedTagValues, this.state.oldcConfirmedTagValues)) {
      return;
    }
    var currentText = "";
    let selectedTags = this.state.intentInTextarea.filter(
      (tag) => tag.selected
    );
    currentText = selectedTags && selectedTags.map((tag) => tag.v).join(",");
    var textToAdd = confirmedTagValues.join(",");
    var newText =
      `我要采购一款${this.state.keyword} 要求是` +
      currentText +
      "," +
      textToAdd;
    if (selectedTags.length === 0 && confirmedTagValues.length === 0) {
      newText = "";
    }

    this.setState(
      { nlq: newText, intent, oldcConfirmedTagValues: confirmedTagValues },
      function () {
        // Focus and set cursor
        if (this.textareaRef) {
          this.textareaRef.focus();
          var newCursorPos = newText.length;
          setTimeout(
            function () {
              if (this.textareaRef) {
                this.textareaRef.setSelectionRange(newCursorPos, newCursorPos);
              }
            }.bind(this),
            0
          );
        }
      }.bind(this)
    );
  }

  handleClear(intent) {
    let { intentInTextarea } = this.state;
    let _intentInTextarea = Array.from(intentInTextarea);
    _intentInTextarea.map((i) => {
      i.selected = false;
    });

    this.setState({
      intentInTextarea: _intentInTextarea,
      nlq: "",
      intent,
    });
  }

  handleKeyDown(event) {
    var isBackspace = event.key === "Backspace";
    var isDelete = event.key === "Delete";

    if (!isBackspace && !isDelete) return;
    console.log(this.textareaRef);
    if (!this.textareaRef) return;

    var textArea = this.textareaRef;
    var start = textArea.selectionStart;
    var end = textArea.selectionEnd;

    // If text is selected, let default behavior handle it
    if (start !== end) return;

    var currentText = this.state.nlq;
    var availableTags = this.state.availableTagValues; // Use the stored list
    var tagFoundAndDeleted = false;

    console.log("111111", currentText);

    for (var i = 0; i < availableTags.length; i++) {
      var tagValue = availableTags[i];
      if (!tagValue) continue; // Skip empty/null tags

      var tagWithLeadingSpace = "," + tagValue;
      var tagWithTrailingSpace = tagValue + ",";

      if (isBackspace && start > 0) {
        console.log("222222");
        var textBeforeCursor = currentText.substring(0, start);
        var tagToRemove = null;
        var tagLengthToRemove = 0;

        // Check for " tagValue"
        if (textBeforeCursor.endsWith(tagWithLeadingSpace)) {
          tagToRemove = tagWithLeadingSpace;
          tagLengthToRemove = tagWithLeadingSpace.length;
        }
        // Check for "tagValue" only if it's the entire text before cursor
        else if (
          textBeforeCursor.endsWith(tagValue) &&
          textBeforeCursor.length === tagValue.length
        ) {
          tagToRemove = tagValue;
          tagLengthToRemove = tagValue.length;
        }

        if (tagToRemove) {
          event.preventDefault();
          var newText =
            textBeforeCursor.slice(0, -tagLengthToRemove) +
            currentText.substring(start);
          var newCursorPos = start - tagLengthToRemove;
          this.setState(
            { nlq: newText },
            function () {
              setTimeout(
                function () {
                  if (this.textareaRef) {
                    this.textareaRef.focus();
                    this.textareaRef.setSelectionRange(
                      newCursorPos,
                      newCursorPos
                    );
                  }
                }.bind(this),
                0
              );
            }.bind(this)
          );

          let _intent = Array.from(this.state.intent);
          let _intentInTextarea = Array.from(this.state.intentInTextarea);
          _intent.map((i) => {
            if (i.v && Array.isArray(i.v)) {
              for (var j = 0; j < i.v.length; j++) {
                var tag = i.v[j];
                if (tag.v === tagValue) {
                  tag.selected = false;
                }
              }
            }
          });

          _intentInTextarea.map((intentInTextareaTag) => {
            if (intentInTextareaTag.v === tagValue) {
              intentInTextareaTag.selected = false;
            }
          });

          this.setState({
            intent: _intent,
            intentInTextarea: _intentInTextarea,
          });

          tagFoundAndDeleted = true;
          break; // Exit loop once a tag is deleted
        }
      } else if (isDelete && start < currentText.length) {
        var textAfterCursor = currentText.substring(start);
        var tagToRemove = null;
        var tagLengthToRemove = 0;

        // Check for "tagValue "
        if (textAfterCursor.startsWith(tagWithTrailingSpace)) {
          tagToRemove = tagWithTrailingSpace;
          tagLengthToRemove = tagWithTrailingSpace.length;
        }
        // Check for "tagValue" only if it's the entire text after cursor
        else if (
          textAfterCursor.startsWith(tagValue) &&
          textAfterCursor.length === tagValue.length
        ) {
          tagToRemove = tagValue;
          tagLengthToRemove = tagValue.length;
        }

        if (tagToRemove) {
          event.preventDefault();
          var newText =
            currentText.substring(0, start) +
            textAfterCursor.slice(tagLengthToRemove);
          var newCursorPos = start; // Cursor stays
          this.setState(
            { nlq: newText },
            function () {
              setTimeout(
                function () {
                  if (this.textareaRef) {
                    this.textareaRef.focus();
                    this.textareaRef.setSelectionRange(
                      newCursorPos,
                      newCursorPos
                    );
                  }
                }.bind(this),
                0
              );
            }.bind(this)
          );

          let _intent = Array.from(this.state.intent);
          let _intentInTextarea = Array.from(this.state.intentInTextarea);
          _intent.map((i) => {
            if (i.v && Array.isArray(i.v)) {
              for (var j = 0; j < i.v.length; j++) {
                var tag = i.v[j];
                if (tag.v === tagValue) {
                  tag.selected = false;
                }
              }
            }
          });

          _intentInTextarea.map((intentInTextareaTag) => {
            if (intentInTextareaTag.v === tagValue) {
              intentInTextareaTag.selected = false;
            }
          });

          this.setState({
            intent: _intent,
            intentInTextarea: _intentInTextarea,
          });

          tagFoundAndDeleted = true;
          break; // Exit loop
        }
      }
    }
    // If tagFoundAndDeleted is false here, the default Backspace/Delete occurs
  }

  handleTagClick(tag) {
    let { intentInTextarea, oldcConfirmedTagValues } = this.state;
    if (tag.selected == true) {
      //todo
      let _intentInTextarea = Array.from(intentInTextarea);
      _intentInTextarea.map((intentInTextareaTag) => {
        if (intentInTextareaTag.v === tag.v) {
          intentInTextareaTag.selected = false;
        }
      });

      var currentText = this.state.nlq;
      let selectedTags = [];
      intentInTextarea.map((tag) => {
        if (tag.selected) {
          selectedTags.push(tag.v);
        }
      });
      selectedTags = selectedTags.concat(oldcConfirmedTagValues);
      let textToAdd = selectedTags.length > 0 && selectedTags.join(",");
      var newText =
        selectedTags.length > 0
          ? `我要采购一款 ${this.state.keyword} 要求是 ` + textToAdd
          : "";

      this.setState({
        intentInTextarea: _intentInTextarea,
        nlq: newText,
      });
    } else {
      var currentText = this.state.nlq;
      var tagWithSpace =
        (currentText.length > 0
          ? ","
          : `我要采购一款 ${this.state.keyword} 要求是 `) + tag.v;
      var newText = currentText + tagWithSpace;

      let _intentInTextarea = Array.from(intentInTextarea);
      _intentInTextarea.map((intentInTextareaTag) => {
        if (intentInTextareaTag.v === tag.v) {
          intentInTextareaTag.selected = true;
        }
      });
      this.setState({ intentInTextarea: _intentInTextarea });

      this.setState(
        { nlq: newText },
        function () {
          // Focus and set cursor after state update
          if (this.textareaRef) {
            this.textareaRef.focus();
            var newCursorPos = newText.length;
            // Use setTimeout for cross-browser consistency
            setTimeout(
              function () {
                if (this.textareaRef) {
                  this.textareaRef.setSelectionRange(
                    newCursorPos,
                    newCursorPos
                  );
                }
              }.bind(this),
              0
            );
          }
        }.bind(this)
      );
    }
  }

  removeSubstring(str, target) {
    // 处理空值情况
    if (!target) return str;

    // 转义正则特殊字符（增强安全性）
    const escaped = target.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // 动态生成正则表达式（flags参数可扩展）
    const regex = new RegExp(escaped, "g");

    return str.replace(regex, "");
  }

  handleKeywordBlur() {
    setTimeout(() => {
      this.setState({ leadsDataSource: [] });
      this.getIntent(this.state.keyword);
    }, 100);
  }

  async onChangeLeadsKeyword(value) {
    // 清除之前的定时器
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.setState({ keyword: value });

    this.debounceTimer = setTimeout(async () => {
      const currentRequestId = ++this.requestCounter;

      try {
        const data = await getSuggestKeywordList(value);

        if (currentRequestId === this.requestCounter) {
          if (data.length > 0) {
            goldlog &&
              goldlog.record(
                "/ifission.ifission.leadsCardExp",
                "EXP",
                `position=suggestList`
              );
          }

          this.setState({ leadsDataSource: data.slice(0, 7) });
        }
      } catch (error) {
        console.error(error);
      }
    }, 300);
  }

  renderGoodsList() {
    const { leadsDataSource, keyword } = this.state;
    return leadsDataSource.map((item) => {
      if (item.queryWords) {
        const arr = item.queryWords.split("");
        const queryWords = arr.map((item) => {
          if (keyword.split("").includes(item)) {
            return <span className="red">{item}</span>;
          } else {
            return item;
          }
        });
        return (
          <div
            className="goods-item"
            title={item.queryWords}
            key={item.queryWords}
            onClick={() => {
              goldlog &&
                goldlog.record(
                  "/ifission.ifission.leadsCardClk",
                  "CLK",
                  `position=suggest&query=${item.queryWords}`
                );
              this.setState({ keyword: item.queryWords, leadsDataSource: [] });
            }}
          >
            {queryWords}
          </div>
        );
      } else {
        return null;
      }
    });
  }

  renderForm() {
    const {
      keyword,
      mobilePhone,
      nlq,
      //volumn,
      isNeedVerification,
      smsCode,
      time,
      intentInTextarea,
      intent,
      leadsDataSource,
    } = this.state;
    return (
      <div>
        <div className="leads-card-content-tip">
          Hi~我是1688采购小助手，为您匹配优质货源，您可以点击一键获取专属服务
        </div>

        <div className="leads-card-content-form">
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">
                采购商品
              </span>
            </div>

            <Input
              maxLength={20}
              onChange={(value) => this.onChangeLeadsKeyword(value)}
              onBlur={this.handleKeywordBlur}
              className="leads-card-content-form-item-input"
              value={keyword}
            />
          </div>
          <div
            className="leads-card-tooltip-list"
            style={{
              height: `${36.5 * leadsDataSource.length}px`,
            }}
          >
            {this.renderGoodsList()}
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-required">*</span>
              <span className="leads-card-content-form-item-text">
                联系电话
              </span>
            </div>
            <Input
              value={mobilePhone}
              maxLength={20}
              onChange={(value) => this.setState({ mobilePhone: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          {isNeedVerification && (
            <div className="leads-card-content-form-item">
              <div className="leads-card-content-form-item-title-wrap">
                <span className="leads-card-content-form-item-required">*</span>
                <span className="leads-card-content-form-item-text">
                  验证码
                </span>
              </div>
              <Input
                className="leads-card-content-form-item-input-smscode"
                type="phone"
                onChange={this.handleSmsCodeChange}
                value={smsCode}
                //placeholder="验证码"
                style={{
                  display: "inlineBlock",
                }}
              />
              <CountdownButton buttonClick={this.getSmsCode}></CountdownButton>
            </div>
          )}
          {/*<div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">采购数量</span>
            </div>
            <Input
              value={volumn}
              maxLength={13}
              onChange={(value) => this.setState({ volumn: value })}
              className="leads-card-content-form-item-input"
            />
          </div>
          */}
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">
                详细要求
              </span>
            </div>
            <div className="label-textarea-container">
              <textArea
                onChange={(e) => this.setState({ nlq: e.target.value })}
                className="leads-card-content-form-item-textArea"
                placeholder="您可以自行输入需求，或直接点击下方符合需求的标签，小助手帮您完善采购需求。"
                value={nlq}
                ref={(el) => (this.textareaRef = el)}
                onKeyDown={this.handleKeyDown}
                maxLength={2000}
              />
              {/* <div className="label-textarea-footer">
                <div
                  ref={this.setTagsContainerRef}
                  className="label-textarea-tags-container"
                >
                  {intentInTextarea.map((tag, index) => (
                    <button
                      key={index}
                      className={
                        "label-textarea-tag-button" +
                        (tag.selected ? " selected" : "")
                      }
                      onClick={() => this.handleTagClick(tag)}
                    >
                      {tag.v}
                    </button>
                  ))}
                  {intentInTextarea.length > 0 && intent.length > 0 && (
                    <button
                      className="label-textarea-more-button"
                      ref={function (ref) {
                        this.moreButtonRef = ref;
                      }.bind(this)}
                      onClick={this.togglePopover}
                    >
                      + 更多
                    </button>
                  )}
                </div>
              </div> */}
            </div>
          </div>
          <div className="leads-card-content-form-item">
            <div className="leads-card-content-form-item-title-wrap">
              <span className="leads-card-content-form-item-text">
                采购周期
              </span>
            </div>
            <CascaderSelect
              dataSource={staticData}
              defaultValue={time}
              size="small"
              onChange={this.handleChangeCascaderSelect}
              className="leads-card-content-form-item-cascaderSelect"
              popupClassName="leads-card-content-form-item-cascaderSelect-popup"
            />
          </div>
        </div>

        {!this.isLogin() && (
          <div className="leads-card-content-login">
            <img
              src="https://img.alicdn.com/imgextra/i2/O1CN0152BmUk1x8nSa1NYdp_!!6000000006399-2-tps-44-44.png"
              className="leads-card-content-login-icon"
            />
            未登录提交后无法查询
            <a
              href={`//login.1688.com/member/signin.htm?Done=${encodeURIComponent(
                window.location.href
              )}`}
              className="leads-card-content-login-link"
            >
              去登录
            </a>
          </div>
        )}

        <div className="leads-card-content-protocol">
          点击提交视为同意
          <a
            href="https://terms.alicdn.com/legal-agreement/terms/c_end_product_protocol/20231031181421701/20231031181421701.html?spm=a261y.25179003.0.0.56883aa7cMyD2U"
            target="_blank"
          >
            《用户协议》
          </a>
        </div>

        <div
          className={`leads-card-content-btn ${this.state.submitFlag ? "leads-card-content-btn-disabled" : ""
            }`}
          onClick={this.handleSubmit}
        >
          提交采购需求
        </div>

        {this.isLogin() && (
          <div
            className="leads-card-content-to-history"
            onClick={this.handleToHistory}
          >
            查看历史采购需求
          </div>
        )}
      </div>
    );
  }

  renderHistory() {
    return (
      <div className="leads-card-content-history">
        {this.state.historyList && this.state.historyList.length > 0 ? (
          <div className="leads-card-content-history-list">
            <div
              className="leads-card-content-history-empty-back"
              onClick={this.handleBackToForm}
            >
              <img
                src="https://img.alicdn.com/imgextra/i4/O1CN010UYxV21jYX5wyxdHB_!!6000000004560-2-tps-212-40.png"
                className="leads-card-content-history-empty-back-icon"
              />
            </div>
            <div className="leads-card-content-history-list-content">
              {this.state.historyList.map((item) => {
                const balloonTrigger = (
                  <div className="leads-card-content-history-list-item-content-line">
                    <span className="leads-card-content-history-list-item-content-line-title">
                      详细需求：{" "}
                    </span>
                    {item.nlq}
                  </div>
                );
                return (
                  <div className="leads-card-content-history-list-item">
                    <div className="leads-card-content-history-list-item-title-line">
                      <Balloon
                        trigger={
                          <div className="leads-card-content-history-list-item-title">
                            求购{item.keyword}
                          </div>
                        }
                      >
                        {item.keyword}
                      </Balloon>
                      <div className="leads-card-content-history-list-item-date">
                        {formatTimestamp(Number(item.submitTime))}提交
                      </div>
                    </div>
                    <div className="leads-card-content-history-list-item-content-line">
                      <span className="leads-card-content-history-list-item-content-line-title">
                        联系电话：{" "}
                      </span>
                      {item.mobilePhone}
                    </div>
                    {item.nlq && item.nlq.length > 0 ? (
                      <Balloon trigger={balloonTrigger}>{item.nlq}</Balloon>
                    ) : (
                      <div className="leads-card-content-history-list-item-content-line">
                        <span className="leads-card-content-history-list-item-content-line-title">
                          详细需求：{" "}
                        </span>
                        {item.nlq}
                      </div>
                    )}

                    <div className="leads-card-content-history-list-item-content-line">
                      <span className="leads-card-content-history-list-item-content-line-title">
                        采购截止日期：{" "}
                      </span>
                      {formatTimestamp(Number(item.authDeadline))}
                    </div>
                    <Balloon
                      className="leads-card-content-history-list-item-tip-container"
                      triggerType="click"
                      trigger={
                        <div
                          className="leads-card-content-history-list-item-btn"
                          onClick={() => {
                            this.setState({
                              btnTipVisible: true,
                              btnTipId: item.leadsId,
                            });
                          }}
                        >
                          停止采购
                        </div>
                      }
                      closable={false}
                      visible={
                        this.state.btnTipVisible &&
                        this.state.btnTipId == item.leadsId
                      }
                    >
                      <div className="leads-card-content-history-list-item-btn-tip">
                        <div className="leads-card-content-history-list-item-btn-tip-text">
                          停止采购后，将不再为您匹配合适的货源
                        </div>
                        <div className="leads-card-content-history-list-item-btn-tip-line">
                          <div
                            className="leads-card-content-history-list-item-btn-tip-cancel"
                            onClick={() => {
                              this.setState({ btnTipVisible: false });
                            }}
                          >
                            我再想想
                          </div>
                          <div
                            className="leads-card-content-history-list-item-btn-tip-confirm"
                            onClick={this.handleStop.bind(this, item.leadsId)}
                          >
                            确认取消
                          </div>
                        </div>
                      </div>
                    </Balloon>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="leads-card-content-history-empty">
            <div
              className="leads-card-content-history-empty-back"
              onClick={this.handleBackToForm}
            >
              <img
                src="https://img.alicdn.com/imgextra/i4/O1CN010UYxV21jYX5wyxdHB_!!6000000004560-2-tps-212-40.png"
                className="leads-card-content-history-empty-back-icon"
              />
            </div>
            <div className="leads-card-content-history-empty-content">
              <img
                src="https://img.alicdn.com/imgextra/i3/O1CN0177V87120FcChWBLuN_!!6000000006820-2-tps-480-260.png"
                className="leads-card-content-history-empty-content-icon"
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCard() {
    const { showHistory } = this.state;
    //console.log(isNeedVerification)

    return (
      <div className="leads-card-content">
        <div className="leads-card-title">
          <div className="leads-card-title-left">
            <img
              src="https://img.alicdn.com/imgextra/i4/O1CN01EovnQz27768t4lmBx_!!6000000007749-2-tps-64-64.png"
              className="leads-card-title-icon"
            />
            <div className="leads-card-title-text">采购助手</div>
          </div>

          <div
            className="leads-card-content-close"
            onClick={this.handleClose}
          ></div>
        </div>

        {showHistory ? this.renderHistory() : this.renderForm()}

        {this.state.showPopover && (
          <TagSelectPopover
            tagSections={this.state.intent}
            position={this.state.popoverPosition}
            onClose={function () {
              this.setState({ showPopover: false });
            }.bind(this)}
            onConfirm={this.handleTagsConfirm} // 使用更新后的确认处理函数
            handleClear={this.handleClear}
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div
        className={classNames('leads-card-container-new', this.props.className)}
      >
        {this.renderCard()}
      </div>
    );
  }
}
